<template>
  <h2 class="block__title" v-html="computedLabel" v-if="term && computedLabel" />
</template>

<script>
import { defineComponent, computed, inject } from 'vue';

export default defineComponent( {
  name: 'SearchTerm',
  setup() {
    const { label, term } = inject( 'searchForm' );

    const computedLabel = computed( () => label.replace( '%s', term.value ) );

    return {
      computedLabel, term
    };
  }
} );
</script>
